import { ButtonVariant, ButtonView } from "common/views/button/Button.view";
import { IDataFragment } from "core/components/FragmentProvider";
import React, {useState} from "react";
import Label from "core/components/label/Label";
import styled from "styled-components";
import ServiceRegistry from "core/util/ServiceRegistry";
import XHRResolverService from "core/service/resolver/impl/XHRResolver.service";
import { Intent } from "@blueprintjs/core";
import { ForumToaster } from "panels/forum/forumActions";
import { ICESelfReportFragmetProps } from "./CESelfReportForm.panel";
import ConfigUtil from "../../core/util/config/ConfigUtil";
import { v4 as uuidv4 } from 'uuid';
import TokenSession from "../../core/util/session/TokenSession";

const StyledDiv = styled.div`{
	display: flex;
    justify-content: flex-start;
    padding: .5em;
    width: 50%;
	& > span{flex: 2}
	& >div{flex: 1}
}`;

export const submit: IDataFragment<ICESelfReportFragmetProps> = {
	name: "submit",
	label: {},
	component: ({entry, config}) => {
		let credits:any[]=[];
		const getMutationQuery=(entry: any)=>{

			return {"query":`mutation($file: Upload!,, $name:String, $description:String, $startDate:String , $endDate:String, $year:Int, $credits: [CESelfParams])
						{createSelfCE(params: { id: 0,name:$name,description: $description,startDate:$startDate,endDate: $endDate,year:$year,credits:$credits }
						, file: $file){ entityId }}`, "variables": {
				//Here pass parameters
					"file": null ,
					"name": entry.name,
					"description": entry.description,
					"startDate":entry.startDate ,
					"endDate": entry.endDate,
					"year":entry.year ,
					"credits": credits
			}};
        }

		const validatedData=()=>{

			if(isNullorEmpty(entry.name) ){
				errorPopup("Please Enter Name");
				return false;
			}
			let isValid= false;

			if(entry.credits){
					//get all keys
					let entryId: string[]= Object.keys(entry.credits);
					entryId.map(key=> {
						let credit= {...entry['credits'][key]};
						credit.value&&credit.value>0&&credits.push({...credit});
					})

					if(credits.length>0){
						isValid= true;
					}
			}
			if(!isValid){
				errorPopup("please enter the credits")
				return false;
			}
            return true;
    }

		const errorPopup=(message)=>{
			ForumToaster.show({
				intent: Intent.DANGER,
				message: message
			});
		}

		const isNullorEmpty=(...values)=>{
			for(var i = 0; i < values.length; i++) {
				if (!values[i] || values[i] == undefined || values[i] == "" || values[i].length == 0){
					return true
				}
			  }
			  return false;
		}

		const requestBody=(entry)=>{
			const formData = new FormData();
			formData.append("operations", JSON.stringify(getMutationQuery(entry)));
			formData.append("map", JSON.stringify({"file":  ["variables.file"]}));
			formData.append("file", entry["certificate"]);
			return formData;
		}

		const onSubmit=()=> {
			if (!validatedData()) return;

			const resolver = ServiceRegistry.get(XHRResolverService);
			const mutation = requestBody(entry);
			const requestId = uuidv4();
			fetch(ConfigUtil.getEnvConfig().graphqlUri, {
				method: 'POST',
				body: mutation,
				headers: new Headers({ 'Authorization': `Bearer ${TokenSession.getToken()}`, "X-Transaction-Id": requestId }),
			}).then(response=>  response.json())
				.then(reqData => {
					//let reqData = JSON.parse(res);
					let data = reqData.data;
					if (reqData.errors) {
						ForumToaster.show({
							intent: Intent.DANGER,
							message: "Error While Record Creation"
						});
					} else if (data['createSelfCE']) {
						ForumToaster.show({
							intent: Intent.SUCCESS,
							message: "Record Created Successful!!"
						});

						setTimeout(() => {
							document.location.replace(document.location.origin + config.redireURL);
						}, 2000)
					}
			}).catch(err => {
				console.log(err);
			});
		}

		return(
		<StyledDiv>
			<ButtonView
				variant={ButtonVariant.PRIMARY}
				viewKey="CESelfCredit.submit"
				onClick={() => {onSubmit();}}
			>
				<Label k="CESelfCredit.submitButton" v="submit"/>
			</ButtonView>
		</StyledDiv>
	)}
};



// WEBPACK FOOTER //
// ./src/panels/addExternalCredit/actionFragments.tsx